/* OnlyCurve — CRO Edition · product page logic (variant picker, « Crée ton set » tiers, sticky ATC, fit finder, gallery) */
(function () {
  'use strict';
  var OC = (window.OC = window.OC || {});
  var T = OC.strings || {};
  var S = OC.settings || {};
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return OC.formatMoney ? OC.formatMoney(c) : (c / 100).toFixed(2); };
  var norm = function (s) { return String(s || '').toLowerCase().trim(); };

  function parseJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    var g = qs('[data-gallery]', root); if (!g || g._ready) return; g._ready = true;
    var track = qs('.gallery__track', g), slides = qsa('.gallery__slide', g), counter = qs('[data-gallery-counter]', g), thumbs = qsa('[data-thumb-index]', root);
    var current = 0, strip = qs('.gallery__thumbs', root);
    var set = function (i) {
      current = i;
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.getAttribute('data-thumb-index'), 10) === i); });
      var t = thumbs[i];
      if (strip && t && strip.scrollWidth > strip.clientWidth + 2) {
        strip.scrollTo({ left: Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
      }
    };
    var go = function (i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      set(i);
    };
    track.addEventListener('scroll', OC.debounce ? OC.debounce(function () { set(Math.round(track.scrollLeft / track.clientWidth)); }, 60) : function () {}, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-thumb-index'), 10)); }); });
    var p = qs('.gallery__nav--prev', g), n = qs('.gallery__nav--next', g);
    p && p.addEventListener('click', function () { go(current - 1); });
    n && n.addEventListener('click', function () { go(current + 1); });
    g.goToMedia = function (mediaId) {
      if (!mediaId) return;
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) go(idx);
    };
    set(0);
  }

  /* ---------- delivery estimate ---------- */
  function initEta(root) {
    qsa('[data-delivery-eta]', root).forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 1, max = parseInt(el.getAttribute('data-max'), 10) || 2;
      var add = function (days) { var d = new Date(); var added = 0; while (added < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) added++; } return d; };
      var f = function (d) { try { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return d.toDateString(); } };
      var out = qs('[data-eta-dates]', el); if (!out) return;
      var a = add(min), b = add(max);
      out.textContent = min === max ? f(a) : f(a) + ' – ' + f(b);
      el.hidden = false;
    });
  }

  /* ---------- size guide: fit finder ---------- */
  function parseRange(txt) {
    var t = String(txt || '').replace(/,/g, '.').replace(/[–—]/g, '-');
    var nums = t.match(/\d+(\.\d+)?/g); if (!nums) return null;
    var a = parseFloat(nums[0]), b = parseFloat(nums[nums.length - 1]);
    return { min: Math.min(a, b), max: Math.max(a, b) };
  }
  function initFitFinder(root, form) {
    qsa('[data-fit-finder]', root).forEach(function (ff) {
      if (ff._ready) return; ff._ready = true;
      var content = qs('[data-size-guide-content]', root), table = content && qs('table', content);
      if (!table) { ff.hidden = true; var tabBtn = qs('[data-tab="finder"]', root); if (tabBtn) { tabBtn.hidden = true; var alt = qs('[data-tab="chart"]', root); alt && alt.click(); } return; }
      var heads = qsa('thead th, tr:first-child th', table).map(function (th) { return norm(th.textContent); });
      if (!heads.length) heads = qsa('tr:first-child td', table).map(function (td) { return norm(td.textContent); });
      var rows = qsa('tbody tr', table).filter(function (tr) { return qsa('td', tr).length > 1; });
      var cols = {};
      heads.forEach(function (h, i) {
        if (h.indexOf('inch') > -1) return;
        if (h.indexOf('poitrine') > -1 || h.indexOf('bust') > -1) cols.bust = i;
        else if (h.indexOf('hanche') > -1 || h.indexOf('hip') > -1) cols.hips = i;
        else if ((h.indexOf('taille') > -1 && h.indexOf('cm') > -1) || h.indexOf('waist') > -1) cols.waist = i;
      });
      qsa('[data-measure]', ff).forEach(function (f) { if (cols[f.getAttribute('data-measure')] === undefined) f.hidden = true; });
      if (cols.waist === undefined && cols.hips === undefined && cols.bust === undefined) { ff.hidden = true; return; }
      var result = qs('[data-fit-result]', ff), btn = qs('[data-fit-compute]', ff);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var best = -1, out = false, any = false;
        ['waist', 'hips', 'bust'].forEach(function (k) {
          if (cols[k] === undefined) return;
          var inp = qs('[data-measure="' + k + '"] input', ff); if (!inp) return;
          var v = parseFloat(String(inp.value).replace(',', '.')); if (!v) return;
          any = true;
          var idx = -1;
          for (var i = 0; i < rows.length; i++) {
            var r = parseRange((qsa('td', rows[i])[cols[k]] || {}).textContent);
            if (r && v <= r.max) { idx = i; break; }
          }
          if (idx === -1) { out = true; idx = rows.length - 1; }
          best = Math.max(best, idx);
        });
        if (!any) { result.hidden = false; result.innerHTML = '<p>' + (T.fitEnter || '') + '</p>'; return; }
        var label = (qsa('td', rows[best])[0] || {}).textContent.trim();
        var match = OC.matchSize ? OC.matchSize(form, label) : null;
        result.hidden = false;
        result.innerHTML = (out ? '<p>' + (T.fitOut || '') + '</p>' : '') +
          '<span>' + (T.fitResult || '') + '</span><strong>' + label + '</strong>' +
          '<p>' + (T.fitTip || '') + '</p>' +
          (match ? '<button type="button" class="btn btn--block mt-16" data-fit-apply="' + match.replace(/"/g, '&quot;') + '">' + (T.fitApply || '') + ' ' + match + '</button>' : '');
        var apply = qs('[data-fit-apply]', result);
        apply && apply.addEventListener('click', function () { OC.selectSize(form, apply.getAttribute('data-fit-apply')); if (OC.closeDrawer) OC.closeDrawer(); });
      });
    });
  }

  /* ---------- product form ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function str(key, fallback) { return T[key] || fallback || ''; }

  function initProduct(root) {
    if (!root || root._ocReady) return; root._ocReady = true;
    var product = parseJSON(qs('[data-product-json]', root)); if (!product) return;
    var stock = parseJSON(qs('[data-stock-json]', root) || { textContent: '{}' }) || {};
    var form = qs('form[data-product-form]', root); if (!form) return;
    var idInput = qs('[name="id"]', form);
    var addBtn = qs('[data-add]', form), addLabel = qs('[data-add-label]', form), addPrice = qs('[data-add-price]', form), buyNow = qs('[data-buy-now]', form);
    var errorBox = qs('[data-error]', form), stockNote = qs('[data-stock-note]', root);
    var priceEl = qs('[data-price]', root), compareEl = qs('[data-compare]', root), saveEl = qs('[data-save]', root);
    var colorIndex = parseInt(root.getAttribute('data-color-index'), 10), sizeIndex = parseInt(root.getAttribute('data-size-index'), 10);
    var lowThreshold = parseInt(root.getAttribute('data-low-stock'), 10) || 0;
    var gallery = qs('[data-gallery]', root);
    var fieldsets = qsa('[data-option-index]', form);
    var optionCount = product.options.length;
    var single = !fieldsets.length && product.variants.length === 1;
    var selected = [];
    var sticky = qs('[data-sticky-atc]', root);
    /* « Crée ton set » */
    var setBox = qs('[data-set]', form);
    var piecesBox = setBox ? qs('[data-set-pieces]', setBox) : null;
    var tiers = setBox ? (setBox.getAttribute('data-tiers') || '0').split(',').map(function (x) { return parseInt(x, 10) || 0; }) : [0];
    var tierFree = !!setBox && setBox.getAttribute('data-free') === '1';
    var threshold = setBox ? (parseInt(setBox.getAttribute('data-threshold'), 10) || 0) : (S.freeShipping || 0);
    form._oc = { product: product };

    // Initial selection = checked inputs only (nothing is preselected unless the URL has ?variant= or an option has one value)
    if (single) selected = product.variants[0].options.slice();
    else {
      fieldsets.forEach(function (fs) {
        var i = parseInt(fs.getAttribute('data-option-index'), 10);
        var c = qs('input:checked', fs); selected[i] = c ? c.value : null;
      });
      for (var k = 0; k < optionCount; k++) if (selected[k] === undefined) selected[k] = null;
    }

    function findVariant(sel) {
      if (sel.some(function (v) { return v === null || v === undefined; })) return null;
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) || null;
    }
    function firstFor(i, val) {
      return product.variants.find(function (v) { return v.options[i] === val && v.available; }) || product.variants.find(function (v) { return v.options[i] === val; });
    }
    // can value `val` of option `i` be bought together with the other values already chosen in `sel`?
    function valueAvailable(sel, i, val) {
      return product.variants.some(function (v) {
        if (v.options[i] !== val || !v.available) return false;
        for (var j = 0; j < optionCount; j++) { if (j !== i && sel[j] !== null && sel[j] !== undefined && v.options[j] !== sel[j]) return false; }
        return true;
      });
    }
    function currentVariant() { return findVariant(selected); }
    function displayVariant() {
      var v = currentVariant(); if (v) return v;
      var match = function (x) { return x.options.every(function (o, i) { return selected[i] === null || o === selected[i]; }); };
      return product.variants.find(function (x) { return match(x) && x.available; }) || product.variants.find(match) || product.variants[0];
    }
    function variantLabel(v) {
      if (!v) return '';
      return v.options.filter(function (o) { return o !== 'Default Title'; }).join(' · ');
    }

    /* set helpers */
    function setLive() { return !!setBox && (!OC.offerState || OC.offerState() === 'live'); }
    function chosenTier() {
      if (!setBox) return 1;
      var r = qs('input[name="set-qty"]:checked', setBox);
      return r ? Math.max(1, Math.min(4, parseInt(r.value, 10) || 1)) : 1;
    }
    function tierQty() { return setLive() ? chosenTier() : 1; }
    function pctFor(n) { return n > 1 ? (tiers[Math.min(n, 4) - 1] || 0) : 0; }
    function unitAfter(price, pct) { return price - Math.floor(price * pct / 100); }
    function pieceRow(n) { return piecesBox ? qs('[data-set-piece="' + n + '"]', piecesBox) : null; }
    function pieceSel(n) {
      var row = pieceRow(n), sel = [];
      for (var i = 0; i < optionCount; i++) { var s = row && qs('[data-piece-option="' + i + '"]', row); sel[i] = s && s.value ? s.value : null; }
      return sel;
    }
    function pieceVariant(n) { return single ? product.variants[0] : findVariant(pieceSel(n)); }
    function pieces(n) {
      var list = [currentVariant()];
      for (var p = 2; p <= n; p++) list.push(pieceVariant(p));
      return list;
    }
    // Estimate like Shopify: the % is taken per cart line (identical pieces share a line), rounded down to the cent
    function setTotal(n, dv) {
      var pct = pctFor(n), lines = {}, total = 0, full = 0;
      pieces(n).forEach(function (v, idx) {
        var x = v || dv, key = v ? String(v.id) : 'unknown' + idx;
        if (!lines[key]) lines[key] = { price: x.price, qty: 0 };
        lines[key].qty++;
      });
      Object.keys(lines).forEach(function (k) {
        var l = lines[k], sub = l.price * l.qty;
        full += sub; total += sub - Math.floor(sub * pct / 100);
      });
      return { total: total, full: full };
    }

    /* what is still missing before we can add to cart? piece 1 = main picker, pieces 2..n = set rows */
    function missing() {
      if (!single) {
        for (var i = 0; i < optionCount; i++) if (selected[i] === null) return { piece: 1, option: i };
      }
      var n = tierQty();
      if (single) return null;
      for (var p = 2; p <= n; p++) {
        var sel = pieceSel(p);
        for (var j = 0; j < optionCount; j++) if (sel[j] === null) return { piece: p, option: j };
      }
      return null;
    }
    function optName(i) { return String(product.options[i] && product.options[i].name ? product.options[i].name : product.options[i] || '').toLowerCase(); }
    function missLabel(m, short) {
      if (m.piece === 1) {
        if (m.option === colorIndex) return short ? str('chooseColorCta') : str('chooseColor');
        if (m.option === sizeIndex) return short ? str('chooseSizeCta') : str('chooseSize');
        return str(short ? 'chooseOptionCta' : 'chooseOption').replace('[option]', optName(m.option));
      }
      return short ? str('setPieceCtaShort') : str('setPieceCta').replace('[index]', m.piece);
    }
    function missError(m) {
      if (m.piece === 1) {
        if (m.option === colorIndex) return str('chooseColorError');
        if (m.option === sizeIndex) return str('chooseSizeError');
        return str('chooseOptionError').replace('[option]', optName(m.option));
      }
      return str('setPieceMissing').replace('[index]', m.piece);
    }
    function flag(m) {
      var el;
      if (m.piece === 1) el = fieldsets.find(function (f) { return parseInt(f.getAttribute('data-option-index'), 10) === m.option; });
      else el = pieceRow(m.piece);
      if (!el) return;
      el.classList.remove('is-error'); void el.offsetWidth; el.classList.add('is-error');
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (m.piece > 1) {
        var s = qs('[data-piece-option="' + m.option + '"]', el);
        if (s) setTimeout(function () { try { s.focus({ preventScroll: true }); } catch (e) { s.focus(); } }, 400);
      }
    }

    function syncPieceOptions() {
      for (var p = 2; p <= 4; p++) {
        var row = pieceRow(p); if (!row || row.hidden) continue;
        var sel = pieceSel(p);
        qsa('[data-piece-option]', row).forEach(function (s) {
          var i = parseInt(s.getAttribute('data-piece-option'), 10);
          qsa('option', s).forEach(function (o) {
            if (!o.value) return;
            if (!o.hasAttribute('data-label')) o.setAttribute('data-label', o.textContent);
            var ok = valueAvailable(sel, i, o.value);
            o.disabled = !ok && o.value !== s.value;
            o.textContent = o.getAttribute('data-label') + (ok ? '' : ' — ' + str('soldOutShort'));
          });
        });
      }
    }

    function renderSet(dv) {
      if (!setBox) return;
      var chosenN = chosenTier(), chosenFree = false;
      qsa('[data-set-opt]', setBox).forEach(function (opt) {
        var k = parseInt(opt.getAttribute('data-set-opt'), 10), pct = pctFor(k), base = dv.price;
        var calc = k === chosenN ? setTotal(k, dv) : { total: unitAfter(base, pct) * k, full: base * k };
        var e = qs('[data-set-each]', opt); if (e) e.textContent = money(unitAfter(base, pct));
        var t = qs('[data-set-total]', opt); if (t) t.textContent = money(calc.total);
        var f = qs('[data-set-full]', opt); if (f) f.textContent = money(calc.full);
        var free = (k > 1 && tierFree) || (threshold > 0 && calc.total >= threshold);
        var perk = qs('[data-set-perk]', opt);
        if (perk) {
          perk.classList.toggle('is-free', free);
          var pf = qs('[data-set-perk-free]', perk), pe = qs('[data-set-perk-fee]', perk);
          if (pf) pf.hidden = !free;
          if (pe) pe.hidden = free;
        }
        opt.classList.toggle('is-selected', k === chosenN);
        if (k === chosenN) chosenFree = free;
      });
      // one delivery line under the tiles, for the chosen tier
      var dl = qs('[data-set-delivery]', setBox);
      if (dl) {
        dl.classList.toggle('is-free', chosenFree);
        var dlf = qs('[data-set-perk-free]', dl), dle = qs('[data-set-perk-fee]', dl);
        if (dlf) dlf.hidden = !chosenFree;
        if (dle) dle.hidden = chosenFree;
      }
      if (!piecesBox) return;
      // extra pieces: under the tiles (or inside the chosen tier when the markup has a slot)
      var slot = qs('[data-set-opt="' + chosenN + '"] [data-set-slot]', setBox);
      if (chosenN > 1) {
        if (slot && piecesBox.parentNode !== slot) slot.appendChild(piecesBox);
        piecesBox.hidden = false;
      } else piecesBox.hidden = true;
      for (var p = 2; p <= 4; p++) { var row = pieceRow(p); if (row) row.hidden = p > chosenN; }
      var first = qs('[data-set-first]', piecesBox), v1 = currentVariant();
      if (first) { first.textContent = v1 ? variantLabel(v1) : first.getAttribute('data-empty'); first.classList.toggle('is-empty', !v1); }
      syncPieceOptions();
    }

    function update() {
      var v = currentVariant(), dv = displayVariant();
      fieldsets.forEach(function (fs) {
        var i = parseInt(fs.getAttribute('data-option-index'), 10);
        qsa('input', fs).forEach(function (inp) {
          inp.closest('label').classList.toggle('is-unavailable', !valueAvailable(selected, i, inp.value));
        });
        var lab = qs('[data-selected-value]', fs);
        if (lab) { lab.textContent = selected[i] || lab.getAttribute('data-placeholder') || ''; lab.classList.toggle('is-placeholder', !selected[i]); }
        fs.classList.remove('is-error');
      });
      if (idInput) idInput.value = v ? v.id : '';
      // main price
      var unit = dv.price, cmp = dv.compare_at_price && dv.compare_at_price > dv.price ? dv.compare_at_price : 0;
      if (priceEl) priceEl.textContent = money(unit);
      if (compareEl) { compareEl.textContent = cmp ? money(cmp) : ''; compareEl.hidden = !cmp; }
      if (saveEl) { saveEl.hidden = !cmp; if (cmp) saveEl.textContent = '-' + Math.round((cmp - unit) * 100 / cmp) + '%'; }
      // set
      renderSet(dv);
      var n = tierQty();
      var qi = qs('[data-qty-input]', form), qty = n === 1 && qi && !setLive() ? Math.max(1, parseInt(qi.value, 10) || 1) : 1;
      var total = n > 1 ? setTotal(n, dv).total : unit * qty;
      var miss = missing();
      var soldOut = !product.available || (v && !v.available);
      // add button
      if (addBtn) {
        addBtn.disabled = !!soldOut;
        if (soldOut) { addLabel.textContent = str('soldOut'); if (addPrice) addPrice.hidden = true; }
        else if (miss) { addLabel.textContent = missLabel(miss); if (addPrice) addPrice.hidden = true; }
        else {
          addLabel.textContent = n > 1 ? str('addSet').replace('[count]', n) : str('addToCart');
          if (addPrice) { addPrice.hidden = false; addPrice.textContent = money(total); }
        }
      }
      if (buyNow) buyNow.disabled = !!soldOut;
      // real low-stock note
      if (stockNote) {
        var q = v ? stock[String(v.id)] : undefined;
        if (v && v.available && q !== undefined && q > 0 && q <= lowThreshold) { stockNote.hidden = false; stockNote.textContent = (q === 1 ? str('lowStockOne') : str('lowStock').replace('[count]', q)); }
        else stockNote.hidden = true;
      }
      if (errorBox) errorBox.hidden = true;
      // whatsapp prefill
      qsa('[data-whatsapp-product]', root).forEach(function (a) {
        var tpl = a.getAttribute('data-template') || '', lbl = variantLabel(v);
        var msg = tpl.replace('[product]', product.title).replace('[url]', window.location.origin + (root.getAttribute('data-url') || ''));
        msg = lbl ? msg.replace('[size]', lbl) : msg.replace(/\s*\(\[size\]\)/, '').replace('[size]', '');
        a.href = 'https://wa.me/' + a.getAttribute('data-number') + '?text=' + encodeURIComponent(msg);
      });
      // sticky bar
      if (sticky) {
        var meta = qs('[data-sticky-meta]', sticky), sb = qs('[data-sticky-btn]', sticky), si = qs('[data-sticky-img] img', sticky);
        var desc = n > 1 ? str('setPiecesLabel', '[count]').replace('[count]', n) : (v ? variantLabel(v) : (miss ? missLabel(miss) : ''));
        if (meta) meta.innerHTML = (desc ? esc(desc) + ' · ' : '') + '<strong>' + esc(money(total)) + '</strong>';
        if (sb) { sb.disabled = !!soldOut; sb.textContent = soldOut ? str('soldOut') : (miss ? missLabel(miss, true) : (n > 1 ? str('addSetShort').replace('[count]', n) : str('addShort'))); }
        if (si && dv.featured_image) { si.src = dv.featured_image.src + (dv.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
      }
      // url
      if (v && root.hasAttribute('data-update-url') && window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
      root.dispatchEvent(new CustomEvent('oc:variant-change', { detail: { variant: v, display: dv } }));
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name && t.name.indexOf('option-') === 0) {
        var i = parseInt(t.name.replace('option-', ''), 10);
        selected[i] = t.value;
        if (i === colorIndex && gallery && gallery.goToMedia) {
          var fv = currentVariant() || firstFor(colorIndex, t.value);
          if (fv && fv.featured_media) gallery.goToMedia(fv.featured_media.id);
        }
        update();
      } else if (t.name === 'set-qty') {
        update();
      } else if (t.hasAttribute && t.hasAttribute('data-piece-option')) {
        var row = t.closest('[data-set-piece]'); if (row) row.classList.remove('is-error');
        update();
      }
    });

    qsa('[data-qty-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = qs('[data-qty-input]', form); if (!inp) return;
        var n = (parseInt(inp.value, 10) || 1) + (b.getAttribute('data-qty-step') === 'plus' ? 1 : -1);
        inp.value = Math.max(1, Math.min(10, n));
        update();
      });
    });

    function showError(msg) { if (errorBox) { errorBox.hidden = false; errorBox.textContent = msg; } else if (OC.toast) OC.toast(msg); }

    function submit(buy) {
      var m = missing();
      if (m) { flag(m); showError(missError(m)); return; }
      var v = currentVariant();
      if (!v) { showError(str('unavailable')); return; }
      if (!v.available) { showError(str('soldOut')); return; }
      var n = tierQty(), list = [v];
      for (var p = 2; p <= n; p++) {
        var pv = pieceVariant(p);
        if (!pv || !pv.available) { flag({ piece: p, option: sizeIndex > -1 ? sizeIndex : 0 }); showError(str('setPieceUnavailable').replace('[index]', p)); return; }
        list.push(pv);
      }
      var counts = {}, order = [];
      list.forEach(function (x) { if (!counts[x.id]) { counts[x.id] = 0; order.push(x.id); } counts[x.id]++; });
      for (var j = 0; j < order.length; j++) {
        var q = stock[String(order[j])];
        if (q !== undefined && counts[order[j]] > q) { showError(str('setStockLow').replace('[count]', q)); return; }
      }
      var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
      if (n === 1) { var qi = qs('[data-qty-input]', form); if (qi && !setLive()) items[0].quantity = Math.max(1, parseInt(qi.value, 10) || 1); }
      var btn = buy ? buyNow : addBtn;
      btn && btn.classList.add('is-loading');
      OC.cart.add(items, { buyNow: !!buy })
        .catch(function (err) { showError(err && err.message ? err.message : str('cartError')); })
        .then(function () { btn && btn.classList.remove('is-loading'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(false); });
    buyNow && buyNow.addEventListener('click', function (e) { e.preventDefault(); submit(true); });

    // sticky ATC — visible whenever the main button is off-screen (after a little scroll)
    if (sticky && addBtn) {
      var html = document.documentElement, ticking = false, shown = false;
      var setVisible = function (on) {
        if (on === shown) return; shown = on;
        sticky.classList.toggle('is-visible', on);
        html.classList.toggle('has-sticky-atc', on);
        html.style.setProperty('--sticky-offset', on ? sticky.offsetHeight + 'px' : '0px');
      };
      var evaluate = function () {
        ticking = false;
        var r = addBtn.getBoundingClientRect();
        var inView = r.top < window.innerHeight - 40 && r.bottom > 60;
        setVisible(!inView && (r.bottom <= 60 || window.scrollY > 320));
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(evaluate); } }, { passive: true });
      window.addEventListener('resize', evaluate);
      evaluate();
      var sb = qs('[data-sticky-btn]', sticky);
      sb && sb.addEventListener('click', function (e) {
        e.preventDefault();
        var m = missing();
        if (m) { flag(m); showError(missError(m)); return; }
        submit(false);
      });
    }

    initGallery(root); initEta(root); initFitFinder(root, form);
    if (OC.initTabs) OC.initTabs(root);
    update();
  }

  /* size helpers used by fit finder */
  OC.matchSize = function (form, label) {
    var inputs = qsa('input[name^="option-"]', form).filter(function (i) { return i.closest('[data-size-option]'); });
    var l = norm(label), hit = null;
    inputs.forEach(function (i) { if (!hit && norm(i.value) === l) hit = i.value; });
    if (!hit) inputs.forEach(function (i) { if (!hit && norm(i.value).split('/').indexOf(l) > -1) hit = i.value; });
    if (!hit) inputs.forEach(function (i) { if (!hit && l.split('/').indexOf(norm(i.value)) > -1) hit = i.value; });
    return hit;
  };
  OC.selectSize = function (form, value) {
    if (!form || value === null || value === undefined) return;
    var inp = qsa('[data-size-option] input', form).find(function (i) { return i.value === value; });
    if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
  };

  OC.initProduct = initProduct;
  function boot() { qsa('[data-product]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();